var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v(_vm._s(_vm.prefix)),(_vm.gold > 0)?[_vm._v(_vm._s(_vm.gold)),_c('IconGold')]:_vm._e(),(_vm.silver > 0 || _vm.gold > 0)?[_vm._v(_vm._s(_vm.silver)),_c('IconSilver')]:_vm._e(),_vm._v(_vm._s(_vm.copper)),_c('IconCopper')],2)}
var staticRenderFns = []

export { render, staticRenderFns }